import { CLEAR_MY_FILES, FETCH_TAGGED_FILES, FETCH_MY_FILES, CLEAR_TAGGED_FILES } from '../actions/types';

const initialState = {
	tagged_files: [],
	my_files: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_TAGGED_FILES:
			return {
				...state,
				tagged_files: [...state.tagged_files, ...action.payload],
			};
		case FETCH_MY_FILES:
			return {
				...state,
				my_files: [...state.my_files, ...action.payload],
			};
		case CLEAR_MY_FILES:
			return {
				...state,
				my_files: [],
			};
		case CLEAR_TAGGED_FILES:
			return {
				...state,
				tagged_files: [],
			};
		default:
			return state;
	}
}
